import { AxiosResponse } from "axios";

import { $axios } from "@/shared/api";

import { IUser } from "../model/types";

class UserService {
  async getMe() {
    const { data } = await $axios.get<string, AxiosResponse<IUser>>("/GetMe");
    return data;
  }
}

export const userService = new UserService();
